export const useStyles = (theme) => ({
    formControl: {
        width: '100%'
    },
    inputTitle: {
        color: 'var(--black) !important',
        fontWeight: 'bold'
    }
})
